import { render, staticRenderFns } from "./LearnPage.vue?vue&type=template&id=3a9a4d92"
import script from "./LearnPage.vue?vue&type=script&lang=js"
export * from "./LearnPage.vue?vue&type=script&lang=js"
import style0 from "./LearnPage.vue?vue&type=style&index=0&id=3a9a4d92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports